import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../routes/RouteConstants";
import { useTenant } from "../../../contexts/TenantContext";
import useProviderChoice from "../hooks/useProviderChoice";
import { shortNameOf } from "../providerChoice";
import ProviderTag from "./ProviderTag";

/**
 * „Borbély / László” with their avatar, then „Módosítás”: whom the guest is booking with, and the
 * way back to the choice. `returnTo` is where a new choice comes back to (the booking page keeps
 * its service if the new provider offers it). Nothing on a tenant with one provider.
 */
const ChosenProviderChip = ({ returnTo, sx }) => {
  const { hasSeveralProviders, displayConfig } = useTenant();
  const { chosenProvider, isAnyone } = useProviderChoice();
  const navigate = useNavigate();
  if (!hasSeveralProviders || (!chosenProvider && !isAnyone)) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} data-testid="chosen-provider" minWidth={0} sx={sx}>
      <ProviderTag provider={chosenProvider} name={isAnyone ? "Bárki" : shortNameOf(chosenProvider)} />
      <Button
        size="small"
        onClick={() => navigate(Routes.PROVIDERS, { state: { returnTo } })}
        sx={{ color: displayConfig?.primaryColor, minWidth: 0, px: 0.5, textTransform: "none", fontSize: 14, flexShrink: 0 }}
      >
        Módosítás
      </Button>
    </Stack>
  );
};

export default ChosenProviderChip;
